import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { FormsModule } from '@angular/forms';
import { MatPaginatorGotoComponent } from './mat-paginator-goto.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [MatPaginatorGotoComponent],
  imports: [CommonModule, FormsModule, MaterialModule, FlexLayoutModule],
  exports: [MatPaginatorGotoComponent],
})
export class MatPaginatorGotoModule {}
